import { ToneDto, ToneDtoImpl } from '../tonedto';

export interface ChildKaroakeListDto extends ToneDto
{
    
}

export class ChildKaroakeListDtoImpl extends ToneDtoImpl implements ChildKaroakeListDto
{
    

    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getkaroakelist/childkaroakelistdto.ts